"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classes = require('./BalanceRow.module.css');

var BalanceRow = function BalanceRow(_a) {
  var asset = _a.asset,
      usdBalance = _a.usdBalance,
      balance = _a.balance;
  return react_1.default.createElement("li", {
    className: classes.balanceRow
  }, react_1.default.createElement("div", {
    className: classes.assetName
  }, asset.name), react_1.default.createElement("div", {
    className: classes.assetBalance
  }, !(usdBalance || balance) && '-', usdBalance ? "$" + usdBalance : balance));
};

exports.default = BalanceRow;